import alert from '@/plugins/alert'
import { FacilityLocation } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    locationData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    locationSearchParams: {},
    totalItems: 0,
    locations: [],
    locationTree: []
  },
  actions: {
    async searchLocationList({ commit, state, dispatch }, query) {
      const locationSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { locationSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.locationSearchParams) {
        const locationSearchParams = {
          ...state.locationSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'level:ASC,code:ASC'
        }

        const [totalItems, locations] = await Promise.all([
          FacilityLocation.count(locationSearchParams),
          FacilityLocation.search(locationSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            locations,
            totalItems,
            itemsPerPage,
            locationSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async fetchLocationTree({ commit }) {
      try {
        const locationTree = await FacilityLocation.getTree()
        commit('changeState', { locationTree })
        return locationTree
      } catch (e) {
        alert.error('Lỗi khi tải sơ đồ vị trí')
      }
    },

    async createLocation({ commit, state }, locationData) {
      try {
        const created = await FacilityLocation.create(locationData)
        commit('changeState', {
          locations: [created, ...state.locations]
        })
        alert.success('Thêm vị trí thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async updateLocation({ commit }, { id, ...locationData }) {
      try {
        const updated = await FacilityLocation.update(id, locationData)
        commit('updateLocation', updated)
        alert.success('Cập nhật vị trí thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async removeLocation({ commit }, id) {
      try {
        await FacilityLocation.remove(id)
        commit('removeLocation', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateLocation(state, locationData) {
      state.locations = state.locations.map(c => (locationData.id === c.id ? locationData : c))
    },
    removeLocation(state, id) {
      state.locations = state.locations.filter(d => d.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  },
  getters: {}
}
